import * as R from 'ramda'
import {
  GetUserByUsername,
  GetUsers,
  reqGetUserByUsername,
  reqGetUsers,
  reqSearchUser,
  SearchUser,
  User,
} from '@weblite/ts-action/user'
import { request } from '$setup/ws'
import { loadAndGetAllPv } from '$logic/pv'
import { getContact, getSignedUpContactIds } from '$logic/contacts/service'
import { getClientUser, getClientUserId } from '$logic/client-user'
import { usersStatusStorage } from './user-status.storage'
import { usersStorage } from './storage'

export async function getUser(userId: string): Promise<User> {
  if (getClientUserId() === userId) return getClientUser() as User

  const { phone, firstname, lastname } = (await getContact(userId)) || {}
  const user = await usersStorage.get(userId)
  return phone ? { ...user, firstname: firstname || '', lastname } : user
}

export async function getUserFromUsersStorage(userId: string): Promise<User> {
  return usersStorage.get(userId)
}

export async function searchUser(
  query: string,
): Promise<{ users: User[]; pvUsers: User[]; pvIds: string[] }> {
  const res = await request<SearchUser>(reqSearchUser({ query }))
  if (!res || !res.payload) return { users: [], pvUsers: [], pvIds: [] }
  const { users, pvUsers, pvIds } = res.payload
  usersStorage.add([...users, ...pvUsers])
  usersStatusStorage.add(
    [...users, ...pvUsers].map(({ id, status }) => ({ id, status })),
  )

  return { users: users.filter(u => u.updatedAt), pvUsers, pvIds }
}

export async function getFamiliarUserIds() {
  const pvs = await loadAndGetAllPv()
  return R.uniq([
    // user pvs
    ...R.pluck('to', pvs),
    // user contacts
    ...getSignedUpContactIds(),
  ])
}

export async function persistUpdateUserRequest(
  users: Record<string, number | null>,
) {
  const res = await request<GetUsers>(reqGetUsers({ users }), {
    retry: -1,
  })
  const resultUsers = res?.payload?.users ?? []
  usersStatusStorage.add(resultUsers.map(({ id, status }) => ({ id, status })))
  return resultUsers.filter(R.prop('updatedAt'))
}

export async function getUserByUsername(username: string) {
  const user = await usersStorage.findByUsername(username)

  if (user)
    // NOTE: Use getUser To load data in redux
    return getUser(user.id)

  const res = await request<GetUserByUsername>(
    reqGetUserByUsername({ username }),
    {
      retry: -1,
    },
  )

  if (res.payload) usersStorage.add(res.payload)
  return res.payload
}
